import { Component, ElementRef, HostBinding, Input, Renderer2, ViewChild } from '@angular/core';

let nextUniqueId = 0;

@Component({
  selector: 'mui-circle-percent',
  templateUrl: './mui-circle-percent.component.html',
  styleUrls: ['./mui-circle-percent.component.scss']
})
export class MuiCirclePercentComponent {
  @Input()
  animateFromZero = false;

  @Input()
  @HostBinding('attr.id')
  id = `mui-circle-percent-${nextUniqueId++}`;

  @Input()
  delay = 500;

  @Input()
  set percent(val: number) {
    this._oldPercent = this._percent;
    this._percent = val;
    this.update(val);
  }

  get percent(): number {
    return this._percent;
  }

  @ViewChild('circleGroup', { static: true })
  private _svgCircleGroup!: ElementRef;

  _percent = 0;
  _oldPercent = 0;
  _circles: SVGCircleElement[] = [];
  hasAnimations = true;

  constructor(private renderer: Renderer2) {}

  update(percent: number): void {
    if (this._circles && this._circles.length === 1 && !this.animateFromZero) {
      this.animateElement(this._circles[0], this._oldPercent, percent, 0);
    } else {
      this.clearCircles();
      let lastPercent = 0;
      let index = 1;
      for (let i = percent; i > 0; i = i - 100) {
        if (i >= 100) {
          this.addCircle(100, index, lastPercent <= 1 ? 0 : lastPercent);
        } else {
          this.addCircle(i, index, lastPercent);
        }
        index++;
        lastPercent += 100;
      }
    }
  }

  private clearCircles(): void {
    if (this._circles) {
      this._circles.forEach((c) => {
        this.renderer.removeChild(this._svgCircleGroup, c);
      });
      this._circles.length = 0;
    }
  }

  private addCircle(percent: number, iteration: number, lastPercent: number): void {
    const color = iteration > 1 ? 'rgb(0 0 0 / 10%)' : '#f59b00';
    const circleElementNew: SVGCircleElement = this.renderer.createElement('circle', 'svg');

    this.renderer.addClass(circleElementNew, 'mui-circle-percent__circle');
    this.renderer.setAttribute(circleElementNew, 'stroke', color);
    this.renderer.appendChild(this._svgCircleGroup.nativeElement, circleElementNew);

    this.animateElement(circleElementNew, 0, percent, lastPercent);
    this._circles.push(circleElementNew);
  }

  private animateElement(element: SVGCircleElement, from: number, to: number, delay: number): void {
    if (this.hasAnimations) {
      const baseDuration = 1500;
      element.animate(
        [
          { strokeDashoffset: `calc( (100% - 14%) * ${Math.PI} / 100 * (100 - ${from}))` },
          { strokeDashoffset: `calc( (100% - 14%) * ${Math.PI} / 100 * (100 - ${to}))` }
        ],
        {
          duration: (Math.abs(to - from) / 100) * baseDuration,
          delay: this.delay + (delay / 100) * baseDuration,
          fill: 'both',
          easing: 'ease-in-out'
        }
      );
    }
  }
}
